var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIEmptyScript = function SvgIEmptyScript(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 81,
    viewBox: "0 0 71 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.168,
    y: 10.0835,
    width: 30.2499,
    height: 5.04165,
    rx: 2.52083,
    fill: "#2C2D35"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.52083 0C1.12861 0 0 1.12861 0 2.52083C0 2.55849 0.00082615 2.59597 0.00246132 2.63323L0.00246088 12.6041C0.00246082 13.9963 1.13107 15.125 2.52329 15.125C3.9155 15.125 5.04412 13.9963 5.04412 12.6041L5.04412 5.04165H12.6041C13.9964 5.04165 15.125 3.91304 15.125 2.52083C15.125 1.12861 13.9964 0 12.6041 0H2.52329H2.52083Z",
    fill: "#2C2D35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0656 80.6665C69.4578 80.6665 70.5864 79.5379 70.5864 78.1457C70.5864 78.108 70.5856 78.0705 70.584 78.0333L70.584 68.0624C70.584 66.6702 69.4554 65.5415 68.0631 65.5415C66.6709 65.5415 65.5423 66.6702 65.5423 68.0624L65.5423 75.6248L57.9823 75.6248C56.5901 75.6248 55.4615 76.7535 55.4615 78.1457C55.4615 79.5379 56.5901 80.6665 57.9823 80.6665L68.0631 80.6665L68.0656 80.6665Z",
    fill: "#2C2D35"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.168,
    y: 20.167,
    width: 30.2499,
    height: 5.04165,
    rx: 2.52083,
    fill: "#2C2D35"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.04346,
    y: 35.2915,
    width: 60.4999,
    height: 10.0833,
    rx: 5.04166,
    fill: "#2C2D35"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.168,
    y: 55.4585,
    width: 30.2499,
    height: 5.04166,
    rx: 2.52083,
    fill: "#2C2D35"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20.168,
    y: 65.5415,
    width: 30.2499,
    height: 5.04166,
    rx: 2.52083,
    fill: "#2C2D35"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIEmptyScript);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/i-empty-script.86a36211aa707c49047f7427dcf7c657.svg";